export default __webpack_public_path__ + "static/Checklist-6d40e225962ae3344c49f8c34ee64bdc.pdf";